import React from 'react'
import { Link } from "react-router-dom";

function NavigationMenu (props){
    return (
        <div>
            <div><h1>Budget Planner</h1></div>
                                    <br/>
                                    <ul>
                                        <li>
                                            <Link 
                                                to="/" 
                                                className="link"
                                                onClick={props.closeMenu}>Home</Link>
                                        </li>
                                        <li>
                                            <Link 
                                                to="/about" 
                                                className="link"
                                                onClick={props.closeMenu}>Budget</Link>
                                        </li>
                                    </ul>  
        </div>
    )
}

export default NavigationMenu
